import { render, staticRenderFns } from "./RevisionSolicitudVer.vue?vue&type=template&id=63ea1f2d"
import script from "./RevisionSolicitudVer.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitudVer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports